module.exports = __webpack_public_path__ + "static/media/03_empauta_mobile.fbc01793.jpg";